import { ObjectBuilder, Image3D, ImgButton, ImgButtonWithText, LayoutUtils, MeshUtils, Rectangle3D } from "@dreamcam/babylon-tools";
import { MeshName, UiMeshNames } from "../MeshName";
import { XRInputHelper } from "../XRInputHelper";
import { Env } from "../../settings/Env";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { text } from "../../TextResources";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
export class SendTipDialog {
    constructor(menuMesh, menuFunctions) {
        this._meshClickListenerHandler = undefined;
        this._addMeshClickListenerHandler = () => {
            if (this._meshClickListenerHandler === undefined) {
                const meshNames = [];
                for (let meshName of UiMeshNames)
                    if (meshName !== MeshName.sendTipDialog) // (exclude "self")
                        meshNames.push(meshName);
                this._meshClickListenerHandler = XRInputHelper.getInstance()?.addClickOnMeshListener(meshNames, (isHit) => {
                    if (isHit)
                        MeshUtils.hide(this._mesh2D);
                });
            }
        };
        this._removeMeshClickListenerHandler = () => {
            if (this._meshClickListenerHandler !== undefined) {
                XRInputHelper.getInstance()?.removeClickOnMeshListener(this._meshClickListenerHandler);
                this._meshClickListenerHandler = undefined;
            }
        };
        this._mesh2D = menuMesh;
        this._menuFunctions = menuFunctions;
        // By default, the panel is hidden.
        this.isVisible = false;
        MeshUtils.setVisibility(this._mesh2D, this.isVisible);
        this._createDialog();
    }
    get isVisible() {
        return this._mesh2D.mesh.isVisible;
    }
    set isVisible(value) {
        if (this.isVisible === value)
            return;
        if (value)
            this._addMeshClickListenerHandler();
        else
            this._removeMeshClickListenerHandler();
        MeshUtils.setVisibility(this._mesh2D, value);
    }
    hide() {
        this.isVisible = false;
    }
    openMessage(position, item, callback) {
        if (position)
            this._mesh2D.mesh.position = position.clone();
        this._item = Object.assign({}, item);
        this._callback = callback;
        this.isVisible = true;
        this._priceTextBlock.text = `${item.price}`;
    }
    _createDialog() {
        const m = Env.broadcast.menu.tipMenu.sendTipDialog;
        const rootContainer = new Rectangle3D("sendTipDialogRoot");
        rootContainer.cornerRadius = this._mesh2D.m2px(Env.broadcast.menu.cornerRadius);
        rootContainer.background = m.backgroundColor;
        rootContainer.thickness = this._mesh2D.m2px(m.borderThickness);
        rootContainer.color = m.borderColor;
        this._mesh2D.texture.addControl(rootContainer);
        const header = ObjectBuilder.createTextBlock3D(this._mesh2D, "sendTipDialogText", text.broadcast_menu_tipMenu_message_purchase_text, m.header);
        rootContainer.addControl(header);
        const stackPanel = new StackPanel("sendTipDialogAmountGroup");
        stackPanel.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        stackPanel.isVertical = false;
        stackPanel.heightInPixels = this._mesh2D.m2px(m.amountGroup.height);
        stackPanel.topInPixels = this._mesh2D.m2px(m.amountGroup.top);
        this._priceTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2D, "sendTipDialogAmountText", "", m.amountGroup.amount);
        stackPanel.addControl(this._priceTextBlock);
        const currencyImage = new Image3D("sendTipDialogAmountCurrency", m.amountGroup.currency.image);
        currencyImage.widthInPixels = this._mesh2D.m2px(m.amountGroup.currency.width);
        currencyImage.heightInPixels = this._mesh2D.m2px(m.amountGroup.currency.height);
        currencyImage.paddingLeftInPixels = this._mesh2D.m2px(m.amountGroup.currency.padding.left);
        stackPanel.addControl(currencyImage);
        rootContainer.addControl(stackPanel);
        const c = m.closeButton;
        const closeButton = new ImgButton("messageDialogCloseButton", c.imageLayout);
        closeButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        closeButton.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        closeButton.widthInPixels = this._mesh2D.m2px(c.width);
        closeButton.heightInPixels = this._mesh2D.m2px(c.height);
        closeButton.paddingLeftInPixels = this._mesh2D.m2px(c.padding.left);
        closeButton.paddingRightInPixels = this._mesh2D.m2px(c.padding.right);
        closeButton.paddingTopInPixels = this._mesh2D.m2px(c.padding.top);
        closeButton.paddingBottomInPixels = this._mesh2D.m2px(c.padding.bottom);
        closeButton.onClickObserver.add(() => {
            this.isVisible = false;
            this._menuFunctions.updateTipMenuButtonLayout();
        });
        rootContainer.addControl(closeButton);
        const btn = m.actionButton;
        this._actionButton = new ImgButtonWithText("messageDialogActionButton", {
            text: text.broadcast_menu_tipMenu_message_purchase_button,
            imageLayout: LayoutUtils.GetButtonLayout(btn.imageLayout, this._mesh2D),
            textLayout: this._mesh2D.textLayoutM2Px(btn.textLayout)
        });
        this._actionButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this._actionButton.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this._actionButton.leftInPixels = this._mesh2D.m2px(btn.left);
        this._actionButton.topInPixels = this._mesh2D.m2px(btn.top);
        this._actionButton.widthInPixels = this._mesh2D.m2px(btn.width);
        this._actionButton.heightInPixels = this._mesh2D.m2px(btn.height);
        this._actionButton.paddingLeftInPixels = this._mesh2D.m2px(btn.padding.left);
        this._actionButton.paddingRightInPixels = this._mesh2D.m2px(btn.padding.right);
        this._actionButton.paddingTopInPixels = this._mesh2D.m2px(btn.padding.top);
        this._actionButton.paddingBottomInPixels = this._mesh2D.m2px(btn.padding.bottom);
        this._actionButton.onClickObserver.add(async () => {
            if (this._callback && this._item !== undefined)
                this._callback(this._item);
        });
        rootContainer.addControl(this._actionButton);
    }
}
